<template>
  <div id="sendCode">
    <button
      type="button"
      class="sendCodeBtn myBtn"
      :class="{inactive: isSending}"
      :disabled="isSending"
    >
      {{ $t(codeBtnTxt) }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeBtnTxt: 'sendCode.init',
      isSending: false,
      timer: null,
      showResend: false
    }
  },
  methods: {
    countDown() {
      if (this.timer === null) {
        this.timer = 'once' // 方便父组件判断是否为null，interval要等1s
        let count = 120
        this.timer = window.setInterval(() => {
          if (count > 0) {
            this.codeBtnTxt = `${count--}s`
            if (!this.isSending) {
              this.isSending = true
            }
          } else {
            this.codeBtnTxt = 'sendCode.end'
            this.isSending = false
            this.showResend = true
            window.clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#sendCode {
  .myBtn {
    width: 100%;
    padding: 0;
  }
  .inactive {
    background-color: $inactive;
  }
}
</style>
